@if (visible) {
  <div class="consent" role="dialog" aria-modal="false" [attr.aria-label]="'consent.title' | t">
    <div class="consent-box">

      @if (closable) {
        <button class="consent-close" type="button" (click)="close()"
          [attr.aria-label]="'common.close' | t">
          <i class="material-icons">close</i>
        </button>
      }

      <h2>{{ 'consent.title' | t }}</h2>
      <p>
        {{ 'consent.intro' | t }}
        <a routerLink="/privacy">{{ 'consent.privacyLink' | t }}</a>.
      </p>

      @if (details) {
        <ul class="consent-categories">
          <li>
            <mat-checkbox [checked]="true" [disabled]="true">
              {{ 'consent.necessary' | t }}
            </mat-checkbox>
            <span class="consent-hint">{{ 'consent.necessaryHint' | t }}</span>
          </li>
          <li>
            <mat-checkbox [(ngModel)]="analytics">{{ 'consent.analytics' | t }}</mat-checkbox>
            <span class="consent-hint">{{ 'consent.analyticsHint' | t }}</span>
          </li>
          <li>
            <mat-checkbox [(ngModel)]="marketing">{{ 'consent.marketing' | t }}</mat-checkbox>
            <span class="consent-hint">{{ 'consent.marketingHint' | t }}</span>
          </li>
        </ul>
      }

      <div class="consent-buttons">
        @if (details) {
          <button mat-stroked-button type="button" (click)="saveChoice()">
            {{ 'consent.saveChoice' | t }}
          </button>
        } @else {
          <button mat-stroked-button type="button" (click)="details = true">
            {{ 'consent.settings' | t }}
          </button>
        }
        <button mat-stroked-button type="button" (click)="rejectAll()">
          {{ 'consent.rejectAll' | t }}
        </button>
        <button mat-flat-button color="primary" type="button" (click)="acceptAll()">
          {{ 'consent.acceptAll' | t }}
        </button>
      </div>

    </div>
  </div>
}
